import { useSubject }                                       from 'ClientService/HookApi';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector }                         from 'react-redux';
import {
    getSpecYears, isFilterRequestLoading,
} from 'Redux/Query';
import { debounceTime, takeUntil }                 from 'rxjs/operators';
import { findSpecYearsRequest }                    from 'Redux/Action';
import Transfer                                    from 'Common/Transfer/Transfer';

export const SpecYearTransfer = ({ value, defaultValue, onChange }) => {

    const dispatch = useDispatch();

    let _defaultValue = defaultValue ?? [];
    _defaultValue = Array.isArray(_defaultValue) ? _defaultValue : [_defaultValue] || [];

    const [ targetKeys, setTargetKeys ] = useState(_defaultValue);

    const onDestroy$ = useSubject(() => {});

    const onSearch$ = useSubject((value) => {
        const filterProps = {
            sorting   : { field: '`Result`.`spec_year`', order: 'ASC' },
            pagination: { page: 1, take: 2000 }
        };
        if (!value || `${value}`.trim() === '') {
            return dispatch(findSpecYearsRequest(filterProps));
        }
        dispatch(findSpecYearsRequest({
            filter: [ { field: '`Result`.`spec_year`', value: `%${value}%` } ],
            ...filterProps,
        }));
    }, takeUntil(onDestroy$), debounceTime(500));

    const specYears = useSelector(getSpecYears);
    const isLoading  = useSelector(isFilterRequestLoading);


    const handleOnChange = useCallback((targetKeys) => {
        setTargetKeys(targetKeys);
        if (onChange && typeof onChange === 'function') {
            onChange(targetKeys);
        }
    }, []);

    const handleOnSearch = useCallback((direction, value) => {
        if (direction === 'right') {
            return;
        }
        onSearch$.next(value);
    }, []);

    useEffect(() => {
        if(!value) { return }
        setTargetKeys(value);
    }, [value]);

    useEffect(() => {
        onSearch$.next();

        return () => {
            onDestroy$.next();
            onDestroy$.complete();
        };
    }, []);

    const dataSource = useMemo(() => {
        return [... new Set([ ...specYears].concat(targetKeys))]
    }, [specYears, targetKeys])

    return (
        <Transfer
            isLoading={isLoading}
            header={[ 'Verfügbare Versionen', 'Ausgewählte Versionen' ]}
            dataSource={dataSource.map(version => ({
                key  : version,
                title: version,
            }))}
            targetKeys={targetKeys}
            locale={{
                itemUnit       : 'Version',
                itemsUnit      : 'Versionen',
                notFoundContent: 'Keine Versionen gefunden',
            }}
            onChange={handleOnChange}
            onSearch={handleOnSearch}
            filterOption={(input, { title }) => `${title}`.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            showSearch
            listStyle={{ height: 400 }}
            render={item => `${item.title}`}
            operations={[ 'zuordnen', 'entfernen' ]}
        />
    );

};
